import * as React from 'react';

/**
 * Text only. Mainly used in placeholder
 */
export const HelpSpan = ({ text }: { text: string }) => {
  return <span>{text}</span>;
};
